<template>
  <Loader :value="promises.fetch" class="post-subpage">
    <Blocks v-if="item.posts" :blocks="config" />
  </Loader>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import BrowserApiMixin from '@/mixins/browser-api'

// pagebuilder
import Config from '@/config/postsSubpage'
import { Blocks } from '@kvass/pagebuilder'

export default {
  mixins: [BrowserApiMixin('post-subpage')],
  props: {
    postSlug: {
      type: String,
      default: 'post',
    },
    slug: {
      type: String,
      default: 'post',
    },
  },
  computed: {
    ...mapState('Root', ['promises', 'item']),
    config() {
      const sources = this.post.customFieldsConfig?.map(schema => schema.source) || ['article']

      return Config[sources[0]].call(this)
    },
    post() {
      if (!this.item.posts) return {}

      const post = this.item.posts.find(p => p.slug === this.slug)

      // redirect
      if (!post) {
        this.$router.push({ name: 'Project' })
      }

      const parent = this.item.posts.find(p => p.slug === this.postSlug)
      if (!parent) return post

      if (
        post.customFieldsConfig[0].source === 'article' &&
        parent.slug !== this.postSlug &&
        parent.customFieldsConfig[0].source === 'news'
      ) {
        this.$router.push({ name: 'Project' })
      }

      return post
    },
  },
  methods: {
    ...mapActions('Root', ['fetch']),
  },
  created() {
    this.fetch()
  },

  metaInfo() {
    return {
      title: this.$path('title', this.post),
    }
  },

  components: {
    Blocks,
  },
}
</script>

<style lang="scss">
.post-subpage {
  .section-breadcrumbs-top {
    @include respond-below('phone') {
      display: none;
    }
    .article__breadcrumbs {
      &--link {
        text-decoration: none;
        &:hover {
          text-decoration: underline;
        }

        &:after {
          content: url("data:image/svg+xml,%3Csvg width='5' height='10' viewBox='0 0 5 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.625 8.75L4.375 5L0.625 1.25' stroke='%23C9CCCF' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
          padding: 0 0.5rem;
        }
      }
    }
  }

  .section-breadcrumbs-bottom {
    padding-block: 3rem;

    &__flex {
      flex-direction: row;
    }

    &__additional-section--theme {
      &-white {
        padding-block: 1rem;
      }
      &-none {
        padding-block: 1rem;
      }
    }

    .link-to-article {
      font-size: 1.3em;

      color: var(--primary);
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }

      @include respond-below('phone') {
        font-size: 1.2rem;
        svg {
          width: 8px;
          height: 14px;
        }
      }
    }
  }
}
</style>
